import { render, staticRenderFns } from "./AppPrivacyMdl.vue?vue&type=template&id=9ab77a1e&"
import script from "./AppPrivacyMdl.vue?vue&type=script&lang=js&"
export * from "./AppPrivacyMdl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports